<inventory-ui-item-pricing-table
  *ngIf="marketId$ | async as marketId"
  [items]="pricingTableItems()"
  [config]="{ partnerId: partnerId, marketId: marketId, businessId: accountGroupId, hideColumns: ['retail_frequency'] }"
  (updatedItemRow)="updateOrderItemUsingItemRow($event)"
  (valid)="setValidity($event)"
  (wholesaleTotal)="setWholesaleTotal($event)"
></inventory-ui-item-pricing-table>

<!-- <mat-card class="order-card" *ngIf="shouldShowFulfillmentSection$ | async">
  <div class="order-fulfillment-container">
    <order-fulfillment></order-fulfillment>
  </div>
</mat-card> -->

<mat-card appearance="outlined" class="order-card" *ngIf="billingAutomationEnabled">
  <mat-card-header>
    <mat-card-title>
      {{ 'ACTIVATION.CONFIRMATION_PAGE.COLLECT_PAYMENT.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-collect-payment
      [partnerId]="partnerId"
      [accountGroupId]="accountGroupId"
      [users]="users$ | async"
      [requireApproval]="requireApproval"
      (requireApprovalChange)="requireApprovalChange.emit($event)"
      [hasExpiryDate]="hasExpiryDate"
      (hasExpiryDateChange)="hasExpiryDateChange.emit($event)"
      [subjectId]="approvalFromSubjectId"
      (subjectIdChange)="approvalFromSubjectIdChange.emit($event)"
      [expiryDate]="expiryDate"
      (expiryDateChange)="expiryDateChange.emit($event)"
    ></app-collect-payment>
  </mat-card-content>
</mat-card>

<!-- Product Activations: Feature Flag -->
<ng-container *ngIf="billingAutomationEnabled">
  <mat-card appearance="outlined" class="order-card">
    <mat-card-header>
      <mat-card-title>
        {{ 'ACTIVATION.CONFIRMATION_PAGE.PRODUCT_ACTIVATIONS.TITLE' | translate }}
      </mat-card-title>
      <mat-card-subtitle>
        {{ 'ACTIVATION.CONFIRMATION_PAGE.PRODUCT_ACTIVATIONS.SUBTITLE' | translate }}
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field appearance="outline" class="contract-start-date-picker">
        <mat-label>
          {{ 'ACTIVATION.CONFIRMATION_PAGE.COLLECT_PAYMENT.SELECT_DATE' | translate }}
        </mat-label>
        <input
          matInput
          readonly
          [matDatepicker]="picker"
          name="date"
          [min]="minStartDate"
          (click)="picker.open()"
          [ngModel]="contractStartDate"
          (ngModelChange)="handleContractStartDateChange($event)"
          required
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker [touchUi]="false"></mat-datepicker>
      </mat-form-field>

      <div class="col col-xs-12">
        <ng-container>
          <div class="contract-start-notice">
            <ng-container *ngIf="requireApproval; then requiresApproval; else activateOnDate"></ng-container>
            <ng-template #requiresApproval>
              {{
                'ACTIVATION.CONFIRMATION_PAGE.PRODUCT_ACTIVATIONS.ACTIVATE_AFTER_PAYMENT'
                  | translate
                    : {
                        date: contractStartDate | date: 'MMMM d, yyyy'
                      }
              }}
            </ng-template>
            <ng-template #activateOnDate>
              {{
                'ACTIVATION.CONFIRMATION_PAGE.PRODUCT_ACTIVATIONS.ACTIVATE_ON_DATE'
                  | translate
                    : {
                        date: contractStartDate | date: 'MMMM d, yyyy'
                      }
              }}
            </ng-template>
          </div>
        </ng-container>
      </div>
      <div *ngIf="(users$ | async)?.length > 0" class="confirm-purchase">
        <mat-checkbox color="primary" [(ngModel)]="emailUsersChecked" [disabled]="emailDisabled"></mat-checkbox>
        <span>
          {{
            activationItemSummaries.length > 1
              ? ('ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.EMAIL_ALL_USERS_MULTI' | translate)
              : ('ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.EMAIL_ALL_USERS' | translate)
          }}
        </span>
        <a type="button" (click)="presentPreviewEmailDialog()">Preview</a>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>

<ng-container *ngIf="!billingAutomationEnabled && (users$ | async)?.length > 0">
  <mat-card appearance="outlined" class="order-card">
    <mat-card-header>
      <mat-card-title>
        {{ 'ACTIVATION.CONFIRMATION_PAGE.PRODUCT_ACTIVATIONS.TITLE' | translate }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="confirm-purchase">
        <mat-checkbox color="primary" [(ngModel)]="emailUsersChecked" [disabled]="emailDisabled"></mat-checkbox>
        <span>
          {{
            activationItemSummaries.length > 1
              ? ('ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.EMAIL_ALL_USERS_MULTI' | translate)
              : ('ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.EMAIL_ALL_USERS' | translate)
          }}
        </span>
        <a type="button" (click)="presentPreviewEmailDialog()">Preview</a>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>

<!--Billing Info-->
<mat-expansion-panel *ngIf="orderItems?.length > 0">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.WHOLESALE_BILLING_INFO' | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="confirmation-section">
    <div>
      <app-order-excess [orderConfirmationItems]="orderItems"></app-order-excess>
      <span *ngIf="approvalMessage">
        {{ approvalMessage }}
        {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.WILL_REQUIRE_CONFIRMATION' | translate }}
        {{
          approvalMessageCount > 1
            ? ('ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.WILL_REMAIN_PENDING_MULTI' | translate)
            : ('ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.WILL_REMAIN_PENDING' | translate)
        }}
      </span>
    </div>
    <div class="billing-info" *ngIf="orderContainsItemsThatAreNotFree || stairStepOrderRequiresBilling">
      <h3>
        {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.BILLED_TO' | translate }}
      </h3>
      <div class="row row-gutters">
        <div class="col col-xs-12 col-md-6">
          <div class="card">
            <app-billing-contact-info
              [editable]="userCanEditBillingInfo"
              [merchantId]="partnerId"
            ></app-billing-contact-info>
          </div>
        </div>
      </div>
      <h3>
        {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.USING_CREDIT_CARD' | translate }}
      </h3>
      <div class="row row-gutters">
        <div class="col col-xs-12 col-md-6">
          <div class="card">
            <app-payment-info [editable]="userCanEditBillingInfo" [merchantId]="partnerId"></app-payment-info>
          </div>
        </div>
        <ng-container *ngIf="creditBalance$ | async as creditBalance">
          <div class="col col-xs-12 col-md-6" *ngIf="creditBalance?.amount > 0">
            <div class="card">
              <div class="balance">
                <mat-icon color="green">card_giftcard</mat-icon>
                <span
                  [innerHtml]="
                    'ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.YOU_HAVE_VCASH'
                      | translate
                        : {
                            amount: creditBalance.amount / 100 | currency: creditBalance.currency : 'symbol'
                          }
                  "
                ></span>
              </div>
              <div class="vcash-description">
                {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.VCASH_WILL_BE_APPLIED' | translate }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="purchase-form-message" *ngIf="activatingProductDisabled && (hasSufficientVCash$ | async) === false">
      {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.YOU_NEED_TO_ADD_BILLING_INFO' | translate }}
    </div>
  </div>
</mat-expansion-panel>

<!-- Actions -->
<glxy-sticky-footer [rightAligned]="true">
  <button
    mat-flat-button
    color="primary"
    data-action="purchase"
    (click)="onSubmit()"
    [disabled]="
      submitDisabled ||
      (activatingProductDisabled && (hasSufficientVCash$ | async) === false) ||
      emailDisabled ||
      !valid
    "
  >
    {{
      billingAutomationEnabled && requireApproval && !!approvalFromSubjectId
        ? ('ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.SEND_ORDER' | translate)
        : ('ACTIVATION.CONFIRMATION_PAGE.ORDER_SUMMARY.PURCHASE' | translate)
    }}
  </button>
  <a mat-stroked-button class="cancel-action" data-action="back" (click)="goBack()" [disabled]="submitDisabled">
    {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
  </a>
</glxy-sticky-footer>
